export default {
    resultadoBuscaTodosAtendimentos: {
        filtros: {
            tipo: {
                default: null,
                data: ['Começa com', 'Contém', 'Termina com'],
                value: ''
            },
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            pacienteId: {
                default: null,
                label: 'Paciente',
                value: null,
            },
            dentistaId: {
                default: null,
                label: 'Dentista',
                value: ''
            },
        },
        paginacao: {
            page: 1,
            size: 5,
            sort: 'dataAlteracao',
            direction: 'DESC',
        }
    },
    resultadoBuscaTodosProcedimentos: {
        filtros: {
            tipo: {
                default: null,
                data: ['Começa com', 'Contém', 'Termina com'],
                value: ''
            },
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            pacienteId: {
                default: null,
                label: 'Paciente',
                value: null,
            },
            dentistaId: {
                default: null,
                label: 'Dentista',
                value: ''
            },
            denteId: {
                default: null,
                label: 'Dente',
                value: ''
            },
            atendimentoId: {
                default: null,
                label: 'Atendimento',
                value: ''
            },
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'dataCadastro',
            direction: 'DESC',
        }
    },
}